import { render, staticRenderFns } from "./OportunitiesV5.vue?vue&type=template&id=9e7b8776&"
import script from "./OportunitiesV5.vue?vue&type=script&lang=js&"
export * from "./OportunitiesV5.vue?vue&type=script&lang=js&"
import style0 from "./OportunitiesV5.vue?vue&type=style&index=0&id=9e7b8776&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports